// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Zjqm","footer":"ModalUpdate_footer__28vA-"};